<template>
  <div id="pricegraph">
    <h3><span>Der Preis-Check für <b>Deinen Autoverkauf</b></span></h3>
    <div class="prices">
      <div class="price super">
        <div class="box">
          <b>Superpreis</b>
          Der Fahrzeugpreis liegt unter dem Marktwerk
        </div>
        <div class="pricebox">&euro; 18.999,-</div>
      </div>

      <div class="price average">
        <div class="box">
          <b>Durchschnitt</b>
          Dieser Fahrzeugpreis entspricht Marktwert
        </div>
        <div class="pricebox">&euro; 18.999,-</div>
      </div>

      <div class="price fair">
        <div class="box">
          <b>Fairer Preis</b>
          Der Fahrzeugpreis entspricht Marktwert
        </div>
        <div class="pricebox">&euro; 18.999,-</div>
      </div>

      <div class="price unfair">
        <div class="box">
          <b>Verhandeln</b>
          Dieser Fahrzeugpreis liegt über Marktwert
        </div>
        <div class="pricebox">&euro; 18.999,-</div>
      </div>
    </div>

    <div id="graph-visualization">
      <span></span>
      <span class="average"></span>
      <span class="fair"></span>
      <span></span>
    </div>
    <div id="graph-labels">
      <span>Superpreis!</span>
      <span>tagesaktueller möglicher Ankaufspreis</span>
      <span>Fahrzeugpreis ist fair!</span>
      <span>Fahrzeugpreis verhandeln!</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name','options', 'label', 'callback', 'model', 'placeholder'],
  data: function() {
    return {
      store: window.Store
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

h3 {
  margin: 40px 0;
  line-height: 26px;
  font-size: 22px;
  text-transform: uppercase;
  font-weight: bold;
  color: $black;

  &:before {
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    background: $grey;
    z-index: 0;
  }

  span {
    background: #fff;
    padding: 0 10px;
  }

  b {
    color: $red;
  }
}

#pricegraph {
  background: #f4f4f4;
  margin: 0 -40px;
  padding: 40px 40px;

  &:after {
    @include clearfix;
  }

  .prices {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  .price {
    width: 25%;

    .box {
      text-align: left;
      padding: 10px;
      width: 80%;
      line-height: 18px;
      font-size: 14px;

      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 15px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 11px 10px 0 20px;
        border-color: $green transparent transparent transparent;
      }

      b {
        display: block;
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 5px;
      }
    }

    .pricebox {
      font-weight: bold;
      font-size: 20px;
      margin: 20px 0 10px 0;
    }

    &.super {
      text-align: left;

      .box {
        background: $green;
        color: #fff;
      }

      .pricebox {
        text-align: left;
        color: $green;
      }
    }

    &.average {
      .box {
        color: $green;
        background: #fff;
        margin: 0 auto;

        &:after {
          border-color: #fff transparent transparent transparent;
        }
      }

      .pricebox {
        color: $green;
      }
    }

    &.fair {
      .box {
        color: #fff;
        background: #7db49f;
        margin: 0 auto;

        &:after {
          border-color: #7db49f transparent transparent transparent;
        }
      }

      .pricebox {
        color: #7db49f
      }
    }

    &.unfair {
      text-align: right;

      .box {
        color: #fff;
        background: #808080;
        margin: auto 0 auto auto;

        &:after {
          border-color: #808080 transparent transparent transparent;
        }
      }

      .pricebox {
        color: #808080;
      }        
    }
  }

  #graph-visualization {
    width: 100%;
    height: 30px;
    background: #fff url(~@/assets/graph-buy.jpg);
    background-repeat: no-repeat;
    background-size: 100% 30px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    span {
      display: block;
      width: 25%;

      &.average,
      &.fair {
        &:after {
          content: '';
          display: block;
          margin-left: 50%;
          width: 2px;
          height: 30px;
        }
      }

      &.average:after { background: $green; }
      &.fair:after { background: #7db49f; }
    }
  }

  #graph-labels {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    span {
      width: 25%;
      color: #808080;
      font-size: 11px;
      padding-top: 5px;

      &:first-child { text-align: left; }
      &:last-child { text-align: right; }
    }
  }
}

@include breakpoint(small) {
  #pricegraph {
    .prices {
      flex-direction: column;
    }

    .price {
      width: 100%;
      margin-bottom: 20px;

      .box { width: 100%; }
      .pricebox { text-align: left; }
    }

    #graph-visualization { display: none; }
    #graph-labels { display: none; }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/summary/SummaryPricegraph.vue